export const NOME_BANCO_DADOS_COMUNS_LEGADO = 'pontotel-cache-comum'

export const solicitarRemocaoCacheDadosComunsLegado = (
  indexedDb: Pick<IDBFactory, 'deleteDatabase'> | undefined = globalThis.indexedDB,
): void => {
  if (!indexedDb) return

  try {
    const requisicao = indexedDb.deleteDatabase(NOME_BANCO_DADOS_COMUNS_LEGADO)
    requisicao.onsuccess = () => undefined
    requisicao.onerror = () => undefined
    requisicao.onblocked = () => undefined
  } catch {
    // Migração best-effort: o bootstrap e a autenticação nunca devem aguardar.
  }
}
